import { Link } from "react-router-dom";
import { Lock, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const Paywall = ({ access }) => {
  const { user } = useAuth();
  const inst = access === "institutional";
  return (
    <div className="relative -mt-32" data-testid="article-paywall">
      <div className="paywall-fade h-32" />
      <div className="bg-[#0A0A0A] text-white p-8 sm:p-10 relative grain">
        <div className="relative">
          <div className="flex items-center gap-2 overline text-[#E5332A]"><Lock size={14} /> {inst ? "Institutional research" : "Pro analysis"}</div>
          <h3 className="font-display text-2xl sm:text-3xl font-bold mt-4 leading-tight">Continue reading with Africa Brew Brief {inst ? "Institutional" : "Pro"}.</h3>
          <ul className="mt-6 space-y-2 text-sm text-[#E7E7E7]/85">
            {["Full weekly analysis and AI key takeaways", "The Monthly Africa Brew Brief Report, included", inst ? "All research papers & sector reports included, team seats" : "Member pricing on research reports"].map((f) => (
              <li key={f} className="flex gap-2"><Check size={16} className="text-[#E5332A] shrink-0" /> {f}</li>
            ))}
          </ul>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link to="/pricing" data-testid="article-paywall-unlock-btn" className="bg-[#E5332A] text-white px-6 py-3 text-sm font-medium hover:bg-[#FF4B40] transition-colors text-center">
              See plans — monthly or annual
            </Link>
            {!user && <Link to="/login" data-testid="article-paywall-login-btn" className="border border-white/30 px-6 py-3 text-sm hover:bg-white/10 transition-colors text-center">I already subscribe</Link>}
          </div>
        </div>
      </div>
    </div>
  );
};
